import LanguageSelectorModal from '@/Components/Localization/LanguageSelectorModal.vue';

export default {
    LanguageSelectorModal,
};